<template>
  <g fill="none" stroke="#333333">
    <rect x="6.5" y="6.5" width="5" height="5" />
    <rect x="2.5" y="2.5" width="13" height="13" />
  </g>
</template>
